import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./career.css";
import Footer from "../../components/Footer/footer";
import { useNavigate } from "react-router-dom";
import Icons from "../../config/images";
import { useDispatch } from "react-redux";
import { getJobListAPI } from "../../store/action/careerAction";
import { addHiringAPI } from "../../store/action/contactAction";
import { UploadMediaRequestAPI } from "../../store/action/mediaAction";
import { toast } from "react-toastify";



const CareerPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [jobList, setJobList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [resumeId, setResumeId] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    user_mobile_number: "",
    cover_letter: "",
    resume: null,
  });

  useEffect(() => {
    dispatch(getJobListAPI({}, (res) => {
      setJobList(res || []);
    }))
  }, [dispatch])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setUploading(true);

    dispatch(
      UploadMediaRequestAPI([file], "career", false, (res) => {
        const uploadedId = res?.data?.[0]?.file_storage_id || res?.data?.file_storage_id;
        setResumeId(uploadedId);
        setUploading(false);
      })
    );
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    if (!resumeId) {
      alert("Please upload resume first");
      return;
    }

    const payload = {
      job_id: selectedJob?.job_id,
      user_name: formData.user_name,
      user_mobile_number: formData.user_mobile_number,
      user_email: formData.user_email,
      user_resume_id: resumeId,
    };

    dispatch(addHiringAPI(payload, (res) => {
      console.log(res);
      if (res.status) {
        toast.success(res?.message?.message || "Application submitted!");
        setFormData({
          user_name: "",
          user_email: "",
          user_mobile_number: "",
          cover_letter: "",
          resume: null,
        })
      }
    }));
    setFormData({
      user_name: "",
      user_email: "",
      user_mobile_number: "",
      cover_letter: "",
      resume: null,
    })
    setResumeId(null)
    setShowForm(false);
  };


  return (
    <>
      <Helmet>
        <title>Careers | BA Code Solutions</title>
      </Helmet>

      <div className="career-page">

        {/* HERO */}
        <section className="career-hero">
          <h1>
            Join <span>BA Code Solutions</span>
          </h1>
          <p>
            Be part of a team building modern digital products for real-world businesses.
          </p>

          {/* <div
            className="contact-us-btn"
          >
            Apply Now
          </div> */}
        </section>

        {/* WHY JOIN US */}
        {/* <section className="career-why">
          <div className="career-container">
            <div className="career-text">
              <h2>
                Why <span>Work With Us</span>
              </h2>

              <p>
                We focus on growth, innovation and building meaningful products.
              </p>

              <ul>
                <li>Work on real-world projects</li>
                <li>Flexible and supportive environment</li>
                <li>Opportunity to grow your skills</li>
                <li>Modern tech stack</li>
              </ul>
            </div>

            <div className="career-image">
              <img src={Icons.career} alt="career" />
            </div>
          </div>
        </section> */}

        {/* JOB LIST */}
        <section className="career-jobs">
          <div className="career-container">
            <h2>
              Open <span>Positions</span>
            </h2>

            <div className="job-grid">
              {jobList?.map((job) => (
                <div key={job.job_id} className="job-card">

                  {/* Top */}
                  <h3>{job.job_title}</h3>

                  {/* Meta Info */}
                  <p className="job-meta">
                    {job.job_location_type?.trim()} • {job.job_experience_required}
                  </p>

                  {/* Department + Type */}
                  <div className="job-tags">
                    <span>{job.job_department}</span>
                    <span>{job.job_type}</span>
                  </div>

                  {/* Description */}
                  <p className="job-description">
                    {job.job_description}
                  </p>

                  {/* CTA */}
                  <div
                    className="contact-us-btn"
                    onClick={() => {
                      setSelectedJob(job);
                      setShowForm(true);
                    }}
                  >
                    Apply Now
                  </div>
                </div>
              ))}
            </div>

          </div>
        </section>

        <Footer />
      </div>
      {showForm && (
        <div className="apply-modal">
          <div className="apply-modal-content">

            <h2>Apply for {selectedJob?.job_title}</h2>

            <form className="apply-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="user_name"
                placeholder="Full Name"
                value={formData.user_name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="user_email"
                placeholder="Email Address"
                value={formData.user_email}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="user_mobile_number"
                placeholder="Phone Number"
                value={formData.user_mobile_number}
                onChange={handleChange}
                required
              />

              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
              />
              {/* Upload Status */}
              <div className="resume-status">
                {uploading && <p className="uploading-text">Uploading resume...</p>}
                {resumeId && <p className="success-text">Resume uploaded ✅</p>}
              </div>
              {/* <textarea
                name="cover_letter"
                placeholder="Cover Letter (optional)"
                value={formData.cover_letter}
                onChange={handleChange}
              /> */}

              <button type="submit">Submit Application</button>
            </form>


            <span className="close-btn" onClick={() => setShowForm(false)}>
              ✖
            </span>
          </div>
        </div>
      )}

    </>
  );
};

export default CareerPage;
